import axios from 'axios';

import { AUTHORIZATION_KEY, GR_BFF_URL, NCA_BFF_URL } from '@/constants';
import { getCookie, merge } from '@/utils';

import {
  HttpClient,
  HttpRequest,
  HttpRequestOptions,
  HttpRequestPostOptions,
  HttpResponse,
  HttpStatusCode,
} from './types';

export const fromBff = (path: string): string => `${NCA_BFF_URL}${path}`;
export const fromRiskBff = (path: string): string => `${GR_BFF_URL}${path}`;

const makeAuthorizationHeaders = (headers: Record<string, any>, useAuthorization: boolean) => {
  if (!useAuthorization) return headers;
  const accessToken = getCookie(AUTHORIZATION_KEY);
  if (!accessToken) return headers;
  return merge(headers || {}, { Authorization: `Bearer ${accessToken}` });
};

export const httpClient: HttpClient = {
  async request<T = any, D = any>(options: HttpRequest<D>): Promise<HttpResponse<T>> {
    const { method, url, data, params, useAuthorization = true } = options;
    const headers = makeAuthorizationHeaders(options.headers, useAuthorization);
    let httpResponse: HttpResponse<T>;

    try {
      const response = await axios.request<T>({ method, url, data, headers, params });
      httpResponse = { body: response.data, status: response.status };
    } catch (error: any) {
      const { status = HttpStatusCode.serverError, data: body = 'Network Error' } = error.response || {};
      httpResponse = { body, status };
    }

    return httpResponse;
  },

  async get<T = any>(url: string, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
    return httpClient.request<T>({ ...options, url, method: 'GET' });
  },

  async post<T = any, D = any>(url: string, data: D, options?: HttpRequestPostOptions): Promise<HttpResponse<T>> {
    return httpClient.request<T, D>({ ...options, url, data, method: 'POST' });
  },
};
